import { JOURNAL_STEP_METADATA, JOURNAL_STEPS } from '@emovia/journal-flow';
import type { LucideIcon } from 'lucide-react';
import {
  Bot,
  CheckCircle,
  GitBranch,
  LayoutGrid,
  Pen,
  Sparkles,
  Zap,
} from 'lucide-react';

import type { FlowStep } from '../flowTypes';
type IconComponent = LucideIcon;

const registry: Record<'zap' | 'sparkles' | 'bot' | 'pen' | 'check-circle' | 'layout-grid' | 'git-branch', IconComponent> = {
  zap: Zap,
  sparkles: Sparkles,
  bot: Bot,
  pen: Pen,
  'check-circle': CheckCircle,
  'layout-grid': LayoutGrid,
  'git-branch': GitBranch,
};

const overrides: Partial<Record<FlowStep, IconComponent>> = {
  cards: LayoutGrid,
  writingChoice: GitBranch,
};

export const JOURNAL_STEP_ICONS: Record<FlowStep, IconComponent> = JOURNAL_STEPS.reduce(
  (acc, step) => {
    const metadata = JOURNAL_STEP_METADATA[step];
    const Icon = overrides[step as FlowStep] ?? registry[metadata.icon as keyof typeof registry] ?? Sparkles;
    acc[step as FlowStep] = Icon;
    return acc;
  },
  {} as Record<FlowStep, IconComponent>,
);

export const getStepIcon = (step: FlowStep): IconComponent => JOURNAL_STEP_ICONS[step] ?? Sparkles;
